import { defineCrestModule } from '@crest/platform-contracts/modules';
import { projectsProjectDetailLauncherCapability } from '@crest/module-projects/contracts/detail-launcher';
import { projectsProjectReferenceAccessHoldCapability } from '@crest/module-projects/contracts/project-reference';
import { platformApprovedActionInvocationReceiptCapability, platformOptionalActionProviderHostCapability, platformOptionalFactProviderHostCapability, platformReceiptBoundActionProviderHostCapability, } from '@crest/platform-contracts/hosts';
import { insuranceClaimsClaimsCapability, insuranceClaimsClaimDeskCapability, insuranceClaimsClaimVersionsCapability, insuranceClaimsProjectSummariesCapability, insuranceClaimsReadinessCapability, insuranceClaimsScopesCapability, insuranceClaimsScopeVersionsCapability, insuranceClaimsEstimateSplitAuditsCapability, insuranceClaimsClaimCoachCapability, insuranceClaimsClaimCoachVersionsCapability, insuranceClaimsSupplementsCapability, insuranceClaimsSupplementVersionsCapability, insuranceClaimsAobNoticesCapability, insuranceClaimsAobNoticeVersionsCapability, insuranceClaimsAobNoticeOwnerEvidenceCapability, insuranceClaimsAdjusterSlaCapability, insuranceClaimsAdjusterSlaOverrideVersionsCapability, insuranceClaimsCarrierEstimateReviewsCapability, insuranceClaimsCarrierEstimateReviewVersionsCapability, insuranceClaimsComplianceReviewsCapability, insuranceClaimsComplianceReviewVersionsCapability, insuranceClaimsComplianceReadinessCapability, insuranceClaimsPaymentAdministrationCapability, insuranceClaimsPaymentAdministrationVersionsCapability, insuranceClaimsImportCapability, insuranceClaimsScopeOwnerEvidenceCapability, insuranceClaimsCustomerPortalIntakeAcceptanceCapability, insuranceClaimsCustomerPortalIntakeAcceptanceProviderId, insuranceClaimsAssistantActionProviderCapability, insuranceClaimsLegacyClaimResolutionProviderId, } from './contracts/index.js';
export const insuranceClaimsModuleManifest = defineCrestModule({
    id: 'insurance-claims',
    version: '1.0.0',
    kind: 'business',
    required: false,
    requires: ['platform', 'projects'],
    requiredCapabilities: [
        'platform.tenant-context.v1',
        'platform.module-access.v1',
        'projects.detail-host.v1',
        projectsProjectDetailLauncherCapability,
        'projects.project-reference.v1',
        projectsProjectReferenceAccessHoldCapability,
        'projects.project-access-decision.v2',
        'platform.storage-object-reference.v1',
        platformOptionalActionProviderHostCapability,
        platformReceiptBoundActionProviderHostCapability,
        platformApprovedActionInvocationReceiptCapability,
        platformOptionalFactProviderHostCapability,
    ],
    optionalCapabilities: [
        'relationships.organizations.v1',
        'relationships.contacts.v1',
        'relationships.insurance-claim-parties.v1',
        'documents.insurance-claim-completion.v1',
        'finance.project-billing-summary.v1',
        'tasks.project-action-summary.v1',
        'documents.signed-authorizations.v1',
        'projects.project-files.v1',
        'scanning-media.scan-captures.v1',
        'mitigation.rooms.v1',
        'mitigation.psychrometrics.v1',
        'mitigation.daily-monitoring.v1',
        'mitigation.drying-workspace.v1',
        'mitigation.treatment-records.v1',
        'mitigation.contents-inventory.v1',
        'mitigation.mold-clearance.v1',
        'assets.placements.v1',
        'estimating.project-estimate-summaries.v1',
        'estimating.estimates.v1',
        'documents.signed-completions.v1',
        'timesheets.project-labor-summary.v1',
        'finance.approved-supplement-consumer.v1',
        'communications.email-delivery.v1',
        'communications.adjuster-correspondence-facts.v1',
        'documents.instances.v1',
        'documents.insurance-claim-notice-artifact.v1',
        'communications.insurance-claim-notice-delivery.v1',
        'documents.insurance-claim-scope-completion.v1',
        'finance.insurance-claim-scope-billing.v1',
    ],
    optionalCapabilityFallbacks: [
        { capability: 'relationships.organizations.v1', degradedMode: 'insurance-claims.degraded.carrier-snapshot.v1' },
        { capability: 'relationships.contacts.v1', degradedMode: 'insurance-claims.degraded.adjuster-snapshot.v1' },
        { capability: 'relationships.insurance-claim-parties.v1', degradedMode: 'insurance-claims.degraded.relationship-parties-unavailable.v1' },
        { capability: 'documents.insurance-claim-completion.v1', degradedMode: 'insurance-claims.degraded.document-completion-unavailable.v1' },
        { capability: 'finance.project-billing-summary.v1', degradedMode: 'insurance-claims.degraded.project-billing-unavailable.v1' },
        { capability: 'tasks.project-action-summary.v1', degradedMode: 'insurance-claims.degraded.project-actions-unavailable.v1' },
        { capability: 'documents.signed-authorizations.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'projects.project-files.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'scanning-media.scan-captures.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.rooms.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.psychrometrics.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.daily-monitoring.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.drying-workspace.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.treatment-records.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.contents-inventory.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'mitigation.mold-clearance.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'assets.placements.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'estimating.project-estimate-summaries.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'estimating.estimates.v1', degradedMode: 'insurance-claims.degraded.estimate-verification-unavailable.v1' },
        { capability: 'documents.signed-completions.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'timesheets.project-labor-summary.v1', degradedMode: 'insurance-claims.degraded.readiness-partial.v1' },
        { capability: 'finance.approved-supplement-consumer.v1', degradedMode: 'insurance-claims.degraded.no-finance-consumer.v1' },
        { capability: 'communications.email-delivery.v1', degradedMode: 'insurance-claims.degraded.no-provider-delivery.v1' },
        { capability: 'communications.adjuster-correspondence-facts.v1', degradedMode: 'insurance-claims.degraded.adjuster-sla-unavailable.v1' },
        { capability: 'documents.instances.v1', degradedMode: 'insurance-claims.degraded.notice-artifact-manual.v1' },
        { capability: 'documents.insurance-claim-notice-artifact.v1', degradedMode: 'insurance-claims.degraded.notice-artifact-unavailable.v1' },
        { capability: 'communications.insurance-claim-notice-delivery.v1', degradedMode: 'insurance-claims.degraded.notice-delivery-unavailable.v1' },
        { capability: 'documents.insurance-claim-scope-completion.v1', degradedMode: 'insurance-claims.degraded.scope-completion-unavailable.v1' },
        { capability: 'finance.insurance-claim-scope-billing.v1', degradedMode: 'insurance-claims.degraded.scope-billing-unavailable.v1' },
    ],
    provides: [
        insuranceClaimsClaimsCapability,
        insuranceClaimsClaimDeskCapability,
        insuranceClaimsClaimVersionsCapability,
        insuranceClaimsSupplementsCapability,
        insuranceClaimsSupplementVersionsCapability,
        insuranceClaimsReadinessCapability,
        insuranceClaimsProjectSummariesCapability,
        insuranceClaimsScopesCapability,
        insuranceClaimsScopeVersionsCapability,
        insuranceClaimsEstimateSplitAuditsCapability,
        insuranceClaimsClaimCoachCapability,
        insuranceClaimsClaimCoachVersionsCapability,
        insuranceClaimsAobNoticesCapability,
        insuranceClaimsAobNoticeVersionsCapability,
        insuranceClaimsAobNoticeOwnerEvidenceCapability,
        insuranceClaimsScopeOwnerEvidenceCapability,
        insuranceClaimsAdjusterSlaCapability,
        insuranceClaimsAdjusterSlaOverrideVersionsCapability,
        insuranceClaimsCarrierEstimateReviewsCapability,
        insuranceClaimsCarrierEstimateReviewVersionsCapability,
        insuranceClaimsComplianceReviewsCapability,
        insuranceClaimsComplianceReviewVersionsCapability,
        insuranceClaimsComplianceReadinessCapability,
        insuranceClaimsPaymentAdministrationCapability,
        insuranceClaimsPaymentAdministrationVersionsCapability,
        insuranceClaimsImportCapability,
        insuranceClaimsCustomerPortalIntakeAcceptanceCapability,
        insuranceClaimsAssistantActionProviderCapability,
    ],
    permissions: [
        'insurance-claims.claims.read',
        'insurance-claims.claims.manage',
        'insurance-claims.supplements.read',
        'insurance-claims.supplements.manage',
        'insurance-claims.supplements.respond',
        'insurance-claims.supplements.paid',
        'insurance-claims.readiness.read',
        'insurance-claims.scopes.read',
        'insurance-claims.scopes.manage',
        'insurance-claims.estimate-split.read',
        'insurance-claims.claim-coach.read',
        'insurance-claims.claim-coach.manage',
        'insurance-claims.aob-notices.read',
        'insurance-claims.aob-notices.manage',
        'insurance-claims.adjuster-sla.read',
        'insurance-claims.adjuster-sla.manage',
        'insurance-claims.carrier-estimate-review.read',
        'insurance-claims.carrier-estimate-review.manage',
        'insurance-claims.compliance.read',
        'insurance-claims.compliance.manage',
        'insurance-claims.compliance.approve',
        'insurance-claims.payment-administration.read',
        'insurance-claims.payment-administration.manage',
        'insurance-claims.import.read',
        'insurance-claims.import.execute',
        'insurance-claims.import.rollback',
    ],
    settings: [
        'insurance-claims.claims.configuration',
        'insurance-claims.claims.display',
        'insurance-claims.copy.workspace',
        'insurance-claims.workflow.configuration',
        'insurance-claims.workflow.display',
        'insurance-claims.copy.workflow',
        'insurance-claims.notice-sla.configuration',
        'insurance-claims.notice-sla.display',
        'insurance-claims.copy.notice-sla',
        'insurance-claims.carrier-review.configuration',
        'insurance-claims.carrier-review.display',
        'insurance-claims.copy.carrier-review',
        'insurance-claims.compliance-payment.configuration',
        'insurance-claims.compliance-payment.display',
        'insurance-claims.copy.compliance-payment',
    ],
    copyCatalogs: [
        'insurance-claims.copy.workspace',
        'insurance-claims.copy.workflow',
        'insurance-claims.copy.notice-sla',
        'insurance-claims.copy.carrier-review',
        'insurance-claims.copy.compliance-payment',
    ],
    events: {
        publishes: [
            'insurance-claims.claim-created.v1',
            'insurance-claims.claim-revised.v1',
            'insurance-claims.claim-status-changed.v1',
            'insurance-claims.claim-archived.v1',
            'insurance-claims.claim-restored.v1',
            'insurance-claims.supplement-created.v1',
            'insurance-claims.supplement-revised.v1',
            'insurance-claims.supplement-submitted.v1',
            'insurance-claims.supplement-approved.v1',
            'insurance-claims.supplement-rejected.v1',
            'insurance-claims.supplement-revision-requested.v1',
            'insurance-claims.supplement-paid.v1',
            'insurance-claims.supplement-archived.v1',
            'insurance-claims.supplement-restored.v1',
            'insurance-claims.scope-created.v1',
            'insurance-claims.scope-revised.v1',
            'insurance-claims.scope-review-ready.v1',
            'insurance-claims.scope-confirmed.v1',
            'insurance-claims.scope-bypassed.v1',
            'insurance-claims.scope-status-changed.v1',
            'insurance-claims.scope-archived.v1',
            'insurance-claims.scope-restored.v1',
            'insurance-claims.claim-coach-step-updated.v1',
            'insurance-claims.aob-notice-created.v1',
            'insurance-claims.aob-notice-revised.v1',
            'insurance-claims.aob-notice-artifact-attached.v1',
            'insurance-claims.aob-notice-delivery-recorded.v1',
            'insurance-claims.aob-notice-acknowledged.v1',
            'insurance-claims.aob-notice-cancelled.v1',
            'insurance-claims.adjuster-sla-override-set.v1',
            'insurance-claims.adjuster-sla-override-cleared.v1',
            'insurance-claims.carrier-estimate-review-created.v1',
            'insurance-claims.carrier-estimate-review-compared.v1',
            'insurance-claims.carrier-estimate-review-line-decided.v1',
            'insurance-claims.carrier-estimate-review-prepared.v1',
            'insurance-claims.compliance-review-created.v1',
            'insurance-claims.compliance-review-revised.v1',
            'insurance-claims.compliance-review-submitted.v1',
            'insurance-claims.compliance-review-approved.v1',
            'insurance-claims.compliance-review-blocked.v1',
            'insurance-claims.compliance-review-retired.v1',
            'insurance-claims.compliance-review-restored.v1',
            'insurance-claims.payment-administration-created.v1',
            'insurance-claims.payment-milestone-updated.v1',
            'insurance-claims.payment-compliance-review-set.v1',
            'insurance-claims.payment-administration-closed.v1',
            'insurance-claims.payment-administration-reopened.v1',
            'insurance-claims.customer-portal-intake-accepted.v1',
        ],
        subscribes: [],
    },
    server: {
        routes: [
            { id: 'insurance-claims.routes.claims', priority: 0 },
            { id: 'insurance-claims.routes.supplements', priority: 10 },
            { id: 'insurance-claims.routes.readiness', priority: 20 },
            { id: 'insurance-claims.routes.scopes', priority: 30 },
            { id: 'insurance-claims.routes.claim-coach', priority: 40 },
            { id: 'insurance-claims.routes.aob-notices', priority: 50 },
            { id: 'insurance-claims.routes.adjuster-sla', priority: 60 },
            { id: 'insurance-claims.routes.carrier-estimate-review', priority: 70 },
            { id: 'insurance-claims.routes.compliance-payment', priority: 80 },
        ],
        jobs: [],
        subscribers: [],
        slots: [{
                id: insuranceClaimsCustomerPortalIntakeAcceptanceProviderId,
                requiredCapability: platformOptionalActionProviderHostCapability,
                requiredPermission: 'insurance-claims.claims.manage',
                priority: 90,
            }, {
                id: insuranceClaimsAssistantActionProviderCapability,
                requiredCapability: platformReceiptBoundActionProviderHostCapability,
                requiredPermission: 'insurance-claims.claims.manage',
                priority: 95,
            }, {
                id: insuranceClaimsLegacyClaimResolutionProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'insurance-claims.claims.read',
                priority: 96,
            }],
    },
    web: {
        routes: [{ id: 'insurance-claims.web.workspace', priority: 0 }],
        navigation: [{ id: 'insurance-claims.navigation.workspace', priority: 75 }],
        slots: [{
                id: 'insurance-claims.web.projects.summary',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'insurance-claims.claims.read',
                priority: 55,
            }, {
                id: 'insurance-claims.web.projects.workflow',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'insurance-claims.scopes.read',
                priority: 54,
            }, {
                id: 'insurance-claims.web.projects.notice-sla',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'insurance-claims.aob-notices.read',
                priority: 53,
            }],
    },
    mobile: { routes: [], slots: [] },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'insurance_claims',
        owns: [
            'insurance_claims.claims',
            'insurance_claims.claim_versions',
            'insurance_claims.claim_events',
            'insurance_claims.claim_commands',
            'insurance_claims.assistant_claim_action_origins',
            'insurance_claims.assistant_claim_owner_safety_commands',
            'insurance_claims.supplement_number_counters',
            'insurance_claims.supplements',
            'insurance_claims.supplement_versions',
            'insurance_claims.supplement_version_lines',
            'insurance_claims.supplement_events',
            'insurance_claims.supplement_commands',
            'insurance_claims.reject_immutable_change',
            'insurance_claims.current_membership_can_read_claim',
            'insurance_claims.current_membership_can_manage_claim',
            'insurance_claims.current_membership_can_read_supplement',
            'insurance_claims.current_membership_can_manage_supplement',
            'insurance_claims.validate_supplement_object_references',
            'insurance_claims.claim_version_record',
            'insurance_claims.claim_record',
            'insurance_claims.supplement_version_record',
            'insurance_claims.supplement_record',
            'insurance_claims.count_claims',
            'insurance_claims.count_supplements',
            'insurance_claims.get_claim_command_receipt',
            'insurance_claims.get_supplement_command_receipt',
            'insurance_claims.write_claim_version',
            'insurance_claims.execute_claim_command',
            'insurance_claims.ecmascript_trim_v1',
            'insurance_claims.utf16_length_v1',
            'insurance_claims.canonical_json_v1',
            'insurance_claims.sha256_json_v1',
            'insurance_claims.assistant_claim_data_v1',
            'insurance_claims.assistant_claim_fields_v1',
            'insurance_claims.assistant_claim_changed_fields_v1',
            'insurance_claims.assistant_clearable_text_valid_v1',
            'insurance_claims.merge_assistant_claim_input_v1',
            'insurance_claims.reject_assistant_claim_evidence_mutation_v1',
            'insurance_claims.lock_current_assistant_claim_scope_v1',
            'insurance_claims.lock_current_assistant_claim_v1',
            'insurance_claims.assert_assistant_claim_limit_v1',
            'insurance_claims.lock_assistant_approved_action_receipt_v1',
            'insurance_claims.apply_assistant_claim_create_v1',
            'insurance_claims.apply_assistant_claim_revise_v1',
            'insurance_claims.execute_assistant_claim_owner_safety_v1',
            'insurance_claims.write_supplement_version',
            'insurance_claims.execute_supplement_command',
            'insurance_claims.list_claims',
            'insurance_claims.get_claim',
            'insurance_claims.get_claim_for_project',
            'insurance_claims.list_claim_versions',
            'insurance_claims.list_supplements',
            'insurance_claims.get_supplement',
            'insurance_claims.list_supplement_versions',
            'insurance_claims.read_supplement_summary',
            'insurance_claims.scopes',
            'insurance_claims.scope_versions',
            'insurance_claims.scope_events',
            'insurance_claims.scope_commands',
            'insurance_claims.claim_coaches',
            'insurance_claims.claim_coach_versions',
            'insurance_claims.claim_coach_events',
            'insurance_claims.claim_coach_commands',
            'insurance_claims.current_membership_can_read_scope',
            'insurance_claims.current_membership_can_manage_scope',
            'insurance_claims.current_membership_can_read_claim_coach',
            'insurance_claims.current_membership_can_manage_claim_coach',
            'insurance_claims.scope_version_record',
            'insurance_claims.scope_record',
            'insurance_claims.claim_coach_version_record',
            'insurance_claims.claim_coach_record',
            'insurance_claims.count_scopes',
            'insurance_claims.get_scope_command_receipt',
            'insurance_claims.execute_scope_command',
            'insurance_claims.list_scopes',
            'insurance_claims.get_scope',
            'insurance_claims.list_scope_versions',
            'insurance_claims.get_claim_coach_command_receipt',
            'insurance_claims.validate_claim_coach_steps',
            'insurance_claims.execute_claim_coach_command',
            'insurance_claims.get_claim_coach',
            'insurance_claims.aob_notices',
            'insurance_claims.aob_notice_versions',
            'insurance_claims.aob_notice_events',
            'insurance_claims.aob_notice_commands',
            'insurance_claims.adjuster_sla_overrides',
            'insurance_claims.adjuster_sla_override_versions',
            'insurance_claims.adjuster_sla_override_events',
            'insurance_claims.adjuster_sla_commands',
            'insurance_claims.current_membership_can_read_aob_notice',
            'insurance_claims.current_membership_can_manage_aob_notice',
            'insurance_claims.current_membership_can_read_adjuster_sla',
            'insurance_claims.current_membership_can_manage_adjuster_sla',
            'insurance_claims.aob_notice_version_record',
            'insurance_claims.aob_notice_record',
            'insurance_claims.adjuster_sla_override_version_record',
            'insurance_claims.adjuster_sla_override_record',
            'insurance_claims.count_active_aob_notices',
            'insurance_claims.get_aob_notice_command_receipt',
            'insurance_claims.list_aob_notices',
            'insurance_claims.get_aob_notice',
            'insurance_claims.list_aob_notice_versions',
            'insurance_claims.execute_aob_notice_command',
            'insurance_claims.get_adjuster_sla_command_receipt',
            'insurance_claims.get_adjuster_sla_override_by_thread',
            'insurance_claims.list_adjuster_sla_overrides',
            'insurance_claims.execute_adjuster_sla_command',
            'insurance_claims.carrier_estimate_reviews',
            'insurance_claims.carrier_estimate_review_versions',
            'insurance_claims.carrier_estimate_review_events',
            'insurance_claims.carrier_estimate_review_commands',
            'insurance_claims.current_membership_can_read_carrier_estimate_review',
            'insurance_claims.current_membership_can_manage_carrier_estimate_review',
            'insurance_claims.carrier_estimate_review_version_record',
            'insurance_claims.carrier_estimate_review_record',
            'insurance_claims.get_carrier_estimate_review_command_receipt',
            'insurance_claims.list_carrier_estimate_reviews',
            'insurance_claims.get_carrier_estimate_review',
            'insurance_claims.list_carrier_estimate_review_versions',
            'insurance_claims.execute_carrier_estimate_review_command',
            'insurance_claims.compliance_reviews',
            'insurance_claims.compliance_review_versions',
            'insurance_claims.compliance_review_events',
            'insurance_claims.compliance_review_commands',
            'insurance_claims.payment_administrations',
            'insurance_claims.payment_administration_versions',
            'insurance_claims.payment_administration_events',
            'insurance_claims.payment_administration_commands',
            'insurance_claims.current_membership_can_read_compliance_review',
            'insurance_claims.current_membership_can_manage_compliance_review',
            'insurance_claims.current_membership_can_approve_compliance_review',
            'insurance_claims.current_membership_can_read_payment_administration',
            'insurance_claims.current_membership_can_manage_payment_administration',
            'insurance_claims.compliance_review_version_record',
            'insurance_claims.compliance_review_record',
            'insurance_claims.payment_administration_version_record',
            'insurance_claims.payment_administration_record',
            'insurance_claims.get_compliance_review_command_receipt',
            'insurance_claims.get_payment_administration_command_receipt',
            'insurance_claims.list_compliance_reviews',
            'insurance_claims.get_compliance_review',
            'insurance_claims.list_compliance_review_versions',
            'insurance_claims.list_payment_administrations',
            'insurance_claims.get_payment_administration',
            'insurance_claims.get_payment_administration_for_claim',
            'insurance_claims.list_payment_administration_versions',
            'insurance_claims.execute_compliance_review_command',
            'insurance_claims.execute_payment_administration_command',
            'insurance_claims.import_domain_totals_valid',
            'insurance_claims.import_runs',
            'insurance_claims.import_identity_map',
            'insurance_claims.import_row_receipts',
            'insurance_claims.import_rejects',
            'insurance_claims.import_rollback_receipts',
            'insurance_claims.begin_import_run',
            'insurance_claims.record_import_reject',
            'insurance_claims.record_import_receipt',
            'insurance_claims.complete_import_run',
            'insurance_claims.fail_import_run',
            'insurance_claims.mark_import_run_rolled_back',
            'insurance_claims.get_import_run',
            'insurance_claims.get_import_run_evidence',
            'insurance_claims.project_intake_insurance_facts',
            'insurance_claims.accept_customer_portal_intake_v1',
        ],
        readsThrough: [
            'projects.project-reference.v1',
            projectsProjectReferenceAccessHoldCapability,
            'projects.project-access-decision.v2',
            'platform.storage-object-reference.v1',
            platformApprovedActionInvocationReceiptCapability,
            'estimating.estimates.v1',
        ],
        migrations: [
            'insurance-claims.claims-supplements-readiness',
            'insurance-claims.scopes-claim-coach',
            'insurance-claims.aob-notices-adjuster-sla',
            'insurance-claims.carrier-estimate-review',
            'insurance-claims.compliance-payment-administration',
            'insurance-claims.import-reconciliation',
            'insurance-claims.customer-portal-intake-acceptance',
            'insurance-claims.project-reference-mutation-holds',
            'insurance-claims.assistant-owner-safety',
            'insurance-claims.assistant-project-assignment-guard',
        ],
    },
    health: ['insurance-claims.database'],
    lifecycle: {
        initialization: { timeoutMs: 5_000, failureBehavior: 'quarantine-module' },
        resources: {
            requestConcurrency: 96,
            jobConcurrency: 0,
            queueBacklogLimit: 0,
            databaseConnectionBudget: 12,
            workerIsolation: 'shared-api',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'skip',
            events: {
                behavior: 'drop-safe',
                durableCursor: false,
                retentionDays: 0,
                backlogLimit: 0,
                warningAt: 0,
                reconciliationProcedure: null,
                dropSafeReason: 'The Claims foundation publishes retained facts but owns no provider or downstream delivery subscriber.',
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'finish-idempotently',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['insurance-claims.database'],
            reconciliationProcedure: insuranceClaimsImportCapability,
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Claims records, source manifests, identity maps, import/reconciliation/rollback evidence, events, and command receipts remain stored while disabled.',
});
//# sourceMappingURL=insurance-claims.module.js.map